
<template>

  <svg viewBox="0 0 68 68" aria-hidden="true">

    <path d="m46.3 48.4c3.8-4.4 9.3-11.4 7.6-21.8-1.8-10.5-11.9-10.6-14.2-9.5-1.4 0.7-3 1-4.1 1.1-0.1-2.4 0.3-7.5 4.3-11.3l-2.1-2.2c-1.5 1.5-2.6 3.1-3.4 4.7-0.5-2-1.4-4.3-3.3-5.9-3.9-3.3-10.3-2-10.3-2s-0.1 6.6 3.8 9.9c2.6 2.2 6.2 2.4 8.4 2.2-0.4 1.8-0.4 3.4-0.4 4.6-1.1-0.1-2.6-0.4-3.9-1.1-2.3-1.2-12.4-1-14.2 9.4s3.7 17.5 7.5 21.9c0.9 1 1.5 1.8 2.3 2.4h19.7c0.8-0.6 1.4-1.4 2.3-2.4z"
    
      fill="currentColor" />

    <path d="m7.8 67.4h56.5l-0.3-1.6c-0.8-3.7-0.8-7.4 0-11.1l0.3-1.6h-56.5c-2.3 0-4.1 1.8-4.1 4v6.4c0 2.1 1.9 3.9 4.1 3.9zm4.3-8.3h44.1c0.6 0 1.1 0.5 1.1 1.1s-0.5 1.1-1.1 1.1h-44.1c-0.6 0-1.1-0.5-1.1-1.1-0.1-0.6 0.4-1.1 1.1-1.1z"
    
      fill="currentColor" />

  </svg>

</template>
